function openMetaModal(cardElement) {
    const modalBody = document.getElementById('metaModalBody');
    const modalOverlay = document.getElementById('metaUniversalModal');
    
    if (cardElement && modalBody && modalOverlay) {
      modalBody.innerHTML = cardElement.innerHTML;
      modalOverlay.classList.add('is-active');
      document.body.style.overflow = 'hidden'; 
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    const modalOverlay = document.getElementById('metaUniversalModal');
    const closeBtn = document.getElementById('metaModalCloseBtn');

    if(closeBtn) {
      closeBtn.addEventListener('click', function(e) {
        e.stopPropagation(); 
        executeClose();
      });
    }

    if(modalOverlay) {
      modalOverlay.addEventListener('click', function(e) {
        if (e.target === modalOverlay) {
          executeClose();
        }
      });
    }

    function executeClose() {
      modalOverlay.classList.remove('is-active');
      document.body.style.overflow = ''; 
      setTimeout(() => {
        document.getElementById('metaModalBody').innerHTML = '';
      }, 200);
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        if(modalOverlay && modalOverlay.classList.contains('is-active')) {
          modalOverlay.classList.remove('is-active');
          document.body.style.overflow = '';
          document.getElementById('metaModalBody').innerHTML = '';
        }
      }
    });

    /* --- MULTI-FILTERING MATRIX LOGIC --- */
    const filterButtons = document.querySelectorAll('.meta-pill-btn');
    const searchInput = document.getElementById('metaCardSearch');
    const sortSelect = document.getElementById('metaCardSort');
    const gridContainer = document.getElementById('metaCardGrid');
    const cards = Array.from(gridContainer.querySelectorAll('.meta-card-item'));

    // Mobile Toggle UI Elements
    const mobileFilterTrigger = document.getElementById('mobileFilterTrigger');
    const filtersContainer = document.getElementById('metaFiltersContainerWrap');
    const activeFiltersSummary = document.getElementById('activeFiltersSummary');
    const summaryPillsWrap = document.getElementById('summaryPillsWrap');
    const metaClearAllBtn = document.getElementById('metaClearAllBtn');

    // Dynamic State Values tracking matrix
    let activeFilters = {
      clan: 'all',
      type: 'all',
      rarity: 'all'
    };
    let searchQuery = '';

    // Pagination state
    const PAGE_SIZE = 12;
    let currentPage = 1;

    // Rarity sort order — mirrors the order of the rarity filter pills
    const RARITY_ORDER = ['rare', 'legendary', 'mythic', 'eternal', 'common'];

    // Mobile Drawer Toggle Event
    if (mobileFilterTrigger) {
      mobileFilterTrigger.addEventListener('click', function() {
        this.classList.toggle('is-open');
        filtersContainer.classList.toggle('is-visible');
      });
    }

    // Pill Interaction Logic
    filterButtons.forEach(btn => {
      btn.addEventListener('click', function(e) {
        const filterType = this.getAttribute('data-filter-type');
        const value = this.getAttribute('data-value');

        if (e.target.classList.contains('meta-pill-close')) {
          e.stopPropagation();
          resetFilterGroup(filterType);
          return;
        }

        document.querySelectorAll(`.meta-pill-btn[data-filter-type="${filterType}"]`).forEach(b => b.classList.remove('active'));
        this.classList.add('active');

        activeFilters[filterType] = value;
        currentPage = 1;
        updateActiveSummaryUI();
        applyFiltersAndSort();
      });
    });

    // Reset single category group
    function resetFilterGroup(filterType) {
      document.querySelectorAll(`.meta-pill-btn[data-filter-type="${filterType}"]`).forEach(b => b.classList.remove('active'));
      const defaultAllBtn = document.querySelector(`.meta-pill-btn[data-filter-type="${filterType}"][data-value="all"]`);
      if(defaultAllBtn) defaultAllBtn.classList.add('active');

      activeFilters[filterType] = 'all';
      currentPage = 1;
      updateActiveSummaryUI();
      applyFiltersAndSort();
    }

    // Clear All Handler
    if (metaClearAllBtn) {
      metaClearAllBtn.addEventListener('click', function() {
        activeFilters.clan = 'all';
        activeFilters.type = 'all';
        activeFilters.rarity = 'all';

        document.querySelectorAll('.meta-pill-btn').forEach(b => b.classList.remove('active'));
        document.querySelectorAll('.meta-pill-btn[data-value="all"]').forEach(b => b.classList.add('active'));

        currentPage = 1;
        updateActiveSummaryUI();
        applyFiltersAndSort();
      });
    }

    // Reconstruct Selected Summary Pills for Meta Display
    function updateActiveSummaryUI() {
      summaryPillsWrap.innerHTML = '';
      let hasActiveFilters = false;

      Object.keys(activeFilters).forEach(type => {
        const val = activeFilters[type];
        if (val !== 'all') {
          hasActiveFilters = true;

          const summaryChip = document.createElement('div');
          summaryChip.className = 'meta-summary-chip';
          summaryChip.innerHTML = `${val} <span class="meta-chip-remove" data-type="${type}">&times;</span>`;

          summaryChip.querySelector('.meta-chip-remove').addEventListener('click', function() {
            resetFilterGroup(type);
          });

          summaryPillsWrap.appendChild(summaryChip);
        }
      });

      activeFiltersSummary.style.display = hasActiveFilters ? 'flex' : 'none';
    }

    // Capture User input strings — debounced to avoid re-render on every keystroke
    let searchDebounceTimer;
    searchInput.addEventListener('input', function() {
      clearTimeout(searchDebounceTimer);
      searchDebounceTimer = setTimeout(() => {
        searchQuery = this.value.trim().toLowerCase();
        currentPage = 1;
        applyFiltersAndSort();
      }, 200);
    });

    // Monitor sorting dropdown matrix values
    sortSelect.addEventListener('change', function() {
      currentPage = 1;
      applyFiltersAndSort();
    });

    // Central Filter + Sort + Pagination Processor
    function applyFiltersAndSort() {
      const sortValue = sortSelect.value;

      // 1. Split into matching vs non-matching
      const matching = [];
      const nonMatching = [];

      // No filter/search active yet — the "default view" hides Common rarity cards.
      // As soon as any clan/type/rarity filter or a search term is applied, Common cards
      // are eligible to show again (subject to matching the active filters as usual).
      const isDefaultView = activeFilters.clan === 'all' &&
                             activeFilters.type === 'all' &&
                             activeFilters.rarity === 'all' &&
                             searchQuery === '';

      cards.forEach(card => {
        const matchesClan   = activeFilters.clan   === 'all' || card.getAttribute('data-clan')   === activeFilters.clan;
        const matchesType   = activeFilters.type   === 'all' || card.getAttribute('data-type')   === activeFilters.type;
        const matchesRarity = activeFilters.rarity === 'all' || card.getAttribute('data-rarity') === activeFilters.rarity;
        const matchesSearch = card.getAttribute('data-name').includes(searchQuery);
        const isHiddenCommonDefault = isDefaultView && card.getAttribute('data-rarity') === 'common';

        if (matchesClan && matchesType && matchesRarity && matchesSearch && !isHiddenCommonDefault) {
          matching.push(card);
        } else {
          nonMatching.push(card);
          card.style.display = 'none';
        }
      });

      // 2. Sort matching cards
      if (sortValue === 'alpha-asc' || sortValue === 'alpha-desc') {
        matching.sort((a, b) => {
          const nameA = a.getAttribute('data-name');
          const nameB = b.getAttribute('data-name');
          return sortValue === 'alpha-asc' ? nameA.localeCompare(nameB) : nameB.localeCompare(nameA);
        });
      } else if (sortValue === 'rarity') {
        matching.sort((a, b) => {
          const rarityA = RARITY_ORDER.indexOf(a.getAttribute('data-rarity'));
          const rarityB = RARITY_ORDER.indexOf(b.getAttribute('data-rarity'));
          const rankA = rarityA === -1 ? RARITY_ORDER.length : rarityA;
          const rankB = rarityB === -1 ? RARITY_ORDER.length : rarityB;
          if (rankA !== rankB) return rankA - rankB;
          return a.getAttribute('data-name').localeCompare(b.getAttribute('data-name'));
        });
      } else {
        // Default order: group by rarity only.
        matching.sort((a, b) => {
          const rarityA = RARITY_ORDER.indexOf(a.getAttribute('data-rarity'));
          const rarityB = RARITY_ORDER.indexOf(b.getAttribute('data-rarity'));
          const rankA = rarityA === -1 ? RARITY_ORDER.length : rarityA;
          const rankB = rarityB === -1 ? RARITY_ORDER.length : rarityB;
          return rankA - rankB;
        });
      }

      // 3. Re-append in sorted order — single reflow via DocumentFragment
      const frag = document.createDocumentFragment();
      matching.forEach(card => frag.appendChild(card));
      nonMatching.forEach(card => frag.appendChild(card));
      gridContainer.appendChild(frag);

      // 4. Apply page slice
      const totalPages = Math.max(1, Math.ceil(matching.length / PAGE_SIZE));
      if (currentPage > totalPages) currentPage = totalPages;

      const start = (currentPage - 1) * PAGE_SIZE;
      const end   = start + PAGE_SIZE;

      matching.forEach((card, i) => {
        card.style.display = (i >= start && i < end) ? 'flex' : 'none';
      });

      // 5. Render pagination controls
      renderPagination(totalPages);
    }

    // Build page number array with ellipsis
    function getPageNumbers(current, total) {
      if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
      const pages = [1];
      if (current > 3) pages.push('...');
      for (let i = Math.max(2, current - 1); i <= Math.min(total - 1, current + 1); i++) pages.push(i);
      if (current < total - 2) pages.push('...');
      pages.push(total);
      return pages;
    }

    function renderPagination(totalPages) {
      const paginationEl = document.getElementById('metaPagination');
      if (!paginationEl) return;

      if (totalPages <= 1) { paginationEl.innerHTML = ''; return; }

      let html = `<button class="meta-page-btn meta-page-prev" data-page="${currentPage - 1}" ${currentPage === 1 ? 'disabled' : ''}>&#8249;</button>`;

      getPageNumbers(currentPage, totalPages).forEach(p => {
        if (p === '...') {
          html += `<span class="meta-page-ellipsis">…</span>`;
        } else {
          html += `<button class="meta-page-btn meta-page-num${p === currentPage ? ' is-active' : ''}" data-page="${p}">${p}</button>`;
        }
      });

      html += `<button class="meta-page-btn meta-page-next" data-page="${currentPage + 1}" ${currentPage === totalPages ? 'disabled' : ''}>&#8250;</button>`;

      paginationEl.innerHTML = html;

      paginationEl.querySelectorAll('.meta-page-btn:not([disabled])').forEach(btn => {
        btn.addEventListener('click', function() {
          currentPage = parseInt(this.getAttribute('data-page'));
          applyFiltersAndSort();
          gridContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    }

    // Initial render
    applyFiltersAndSort();
  });